import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Plant({
  id = 'plant.glb',
  position = [0, 0, 0],
  showMessage,
  closestSkateboard,
}) {
  const { nodes, materials } = useGLTF(`/${id}`)

  if (!nodes || !materials) {
    return (
      <mesh>
        <boxBufferGeometry args={[1, 1, 1]} />
        <meshBasicMaterial color='red' />
      </mesh>
    )
  }

  const plantRef = useRef()

  return (
    <group dispose={null}>
      <group name='Scene'>
        <group ref={plantRef} name='Plant' position={position} rotation={[0, 0, 0]} scale={4}>
          <mesh castShadow name='Clay' geometry={nodes.Clay.geometry}>
            <meshStandardMaterial color='#3b2010' roughness={1} />
          </mesh>
          <mesh
            castShadow
            name='PlantMonstera'
            geometry={nodes.PlantMonstera.geometry}
            material={materials['Plant']}
          />
          <mesh castShadow name='Vase' geometry={nodes.Vase.geometry}>
            <meshStandardMaterial color='#f0ede8' roughness={0.2} metalness={0.1} />
          </mesh>
        </group>
      </group>
    </group>
  )
}
